<template>
  <b-modal
    id="preview-modal"
    ref="modal"
    no-stacking
    size="sm"
    centered
    hide-header
    hide-footer
    content-class="header-preview-web-app"
    dialog-class="qr-preview-modal"
    lazy
    modal-class="px-0"
    @hidden="handleModalClose"
    @shown="handleModalShow"
  >
    <b-row
      class="justify-content-between mx-auto"
      style="max-width: 1000px"
    >
      <b-col class="text-center px-0 position-relative">
        <template v-if="currentBranch">
          <iframe
            v-show="frameLoaded"
            class="preview-web-app no-margin-top"
            allowfullscreen
            :src="qr_link"
            @load="frameLoaded = true"
            @error="frameError = $event"
          />
        </template>
        <template>
          <div
            v-if="!frameLoaded || frameError"
            class="preview-web-app bg-dark mx-auto"
          >
            <div class="h-100">
              <div class="h-100 d-flex justify-content-center align-items-center">
                <div
                  v-if="frameError"
                  class="text-center"
                >
                  <div><i class="fas fa-exclamation-triangle text-danger text-light" /></div>
                  <div class="text-light">
                    {{ frameError }}
                  </div>
                </div>
                <i
                  v-else
                  class="fas fa-spinner fa-spin text-large text-light"
                />
              </div>
            </div>
          </div>
        </template>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { WEBAPP_URL } from '@/constants/config'

export default {
  name: 'QrMenuPreviewModal',
  components: {
    BModal, BRow, BCol,
  },
  data() {
    return {
      qr_link: '',
      frameLoaded: false,
      frameError: null,
    }
  },
  computed: {
    ...mapGetters({
      currentBranch: 'branches/currentBranch',
    }),
  },
  watch: {
    currentBranchId() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.qr_link = `${WEBAPP_URL}/${this.currentBranch.reference_id}`
    },
    handleModalClose() {
      this.frameLoaded = false
      this.frameError = null
      document.documentElement.style.overflowY = 'auto'
      document.documentElement.style.overscrollBehaviorY = 'auto'
    },
    handleModalShow() {
      document.documentElement.style.overflowY = 'hidden'
      document.documentElement.style.overscrollBehaviorY = 'contain'
    },
  },
}
</script>
